import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterLangId'
})
export class FilterLangIdPipe implements PipeTransform {

  transform(list: any[],langId): any[] {
    return list.filter(item => item.m_language_id == langId);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/pipes/filter-langu-id.pipe.ts